/**
 * Toggle switch.
 *
 * Extracted from AdminSettingsPage.tsx (Sub-PR 6.3).
 */

interface ToggleProps {
  enabled: boolean
  onChange: (value: boolean) => void
  label: string
}

export function Toggle({ enabled, onChange, label }: ToggleProps): React.ReactElement {
  return (
    <label className="flex cursor-pointer items-center gap-3">
      <button
        type="button"
        role="switch"
        aria-checked={enabled}
        onClick={() => {
          onChange(!enabled)
        }}
        className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-[var(--accent)] focus:ring-offset-2 focus:outline-none ${
          enabled ? 'bg-[var(--accent)]' : 'bg-[var(--accent-dim)]'
        }`}
      >
        <span
          className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
            enabled ? 'translate-x-5' : 'translate-x-0'
          }`}
        />
      </button>
      <span className="text-sm text-[var(--text-dim)]">{label}</span>
    </label>
  )
}
